import NotificationConfig from "./NotificationConfig";
import AuthService from "../auth/AuthService"
export default class NotificationService {
  /******* NOTIFICATIONS **********/
  static getNotifications(app) {
    
    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = NotificationConfig.endpointNotifications;
        let response = await NotificationConfig.APIConnector.get(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static saveNotification(app,notification) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = NotificationConfig.endpointSaveNotification;
        let response = await NotificationConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify(notification)
        });
        // console.log("RESPONSE SAVE NOTIFICATION",response)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static deleteNotification(app,notificationId) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = NotificationConfig.endpointDeleteNotification;
        let response = await NotificationConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({id:notificationId})
        });
        // console.log("RESPONSE DELETE Notification",response, notificationId)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  /******** FIN NOTIFICATIONS *********/
}


// WEBPACK FOOTER //
// ./src/provider/notification/NotificationsService.js